export default "__VITE_ASSET__Ddp9Gc7y__"